import { c as _c } from "react/compiler-runtime";
import { useAppSelector } from "@store/store-helper";
import { fetchingTeamsFlagsSelector } from "@store/teams/teams-selector";
import { useMediaQueryList } from "@hooks/use-media-query";
import { TeamsEmptyPage } from "@pages/members/teams/teams-empty-page";
import { TeamsMobileView } from "@pages/members/teams/teams-mobile-view";
import { ColumnPreferencesProvider } from "@context-providers/table/column-preferences-provider";
import { TEAMS_TABLE_COLUMNS } from "@components/table/teams/teams-table-constants";
import { TeamsTable } from "@components/table/teams/teams-table";
/** Wrapper component for the TeamsTable that handles different views and empty states */
export function TeamsTableWrapper(t0) {
  const $ = _c(16);
  const {
    companyId,
    sortedTeams,
    isFiltering,
    isLoadingFilters,
    buttonComponents,
    sortBy,
    setSortBy
  } = t0;
  const {
    status
  } = useAppSelector(fetchingTeamsFlagsSelector);
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const shouldShowEmptyPage = sortedTeams.length === 0 && status === "succeeded" && !isLoadingFilters || status === "rejected";
  const isLoading = status === "pending" || isLoadingFilters;
  if (shouldShowEmptyPage) {
    let t1;
    if ($[0] !== isFiltering || $[1] !== status) {
      t1 = <TeamsEmptyPage status={status} isFiltering={isFiltering} />;
      $[0] = isFiltering;
      $[1] = status;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (isScreenSmOrSmaller) {
    let t1;
    if ($[3] !== isLoading || $[4] !== sortBy || $[5] !== sortedTeams) {
      t1 = <TeamsMobileView teams={sortedTeams} isLoading={isLoading} sortBy={sortBy} />;
      $[3] = isLoading;
      $[4] = sortBy;
      $[5] = sortedTeams;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
  let t1;
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [...TEAMS_TABLE_COLUMNS];
    t2 = {
      nonConfigurableColumns: ["options"],
      defaultVisibleColumns: ["name", "users", "creationDate", "workspaceRole"]
    };
    $[7] = t1;
    $[8] = t2;
  } else {
    t1 = $[7];
    t2 = $[8];
  }
  let t3;
  if ($[9] !== buttonComponents || $[10] !== companyId || $[11] !== isLoading || $[12] !== setSortBy || $[13] !== sortBy || $[14] !== sortedTeams) {
    t3 = <ColumnPreferencesProvider tableKey="teams-table" columns={t1} options={t2}><TeamsTable companyId={companyId} teams={sortedTeams} isLoading={isLoading} bulkActionButtons={buttonComponents} sortBy={sortBy} setSortBy={setSortBy} /></ColumnPreferencesProvider>;
    $[9] = buttonComponents;
    $[10] = companyId;
    $[11] = isLoading;
    $[12] = setSortBy;
    $[13] = sortBy;
    $[14] = sortedTeams;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
}